import { __awaiter, __generator } from "tslib";
var GOTO_DELAY = 1000;
var WindowManagerClass = /** @class */ (function () {
    function WindowManagerClass() {
    }
    WindowManagerClass.prototype.new = function () {
        return window.open('about:blank');
    };
    WindowManagerClass.prototype.goto = function (_a) {
        var url = _a.url, handle = _a.handle;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                if (handle) {
                    handle.location.href = url;
                }
                return [2 /*return*/, new Promise(function (resolve) {
                        setTimeout(function () {
                            resolve();
                        }, GOTO_DELAY);
                    })];
            });
        });
    };
    return WindowManagerClass;
}());
export { WindowManagerClass };
export var windowManager = new WindowManagerClass();
//# sourceMappingURL=windowManager.js.map